import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

const PageResearchNotificationsAnscOperatorInitizializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={{}}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageResearchNotificationsAnscOperatorInitizializer.displayName =
  'Page Research Notifications Ansc Operator Initizializer component';

export default PageResearchNotificationsAnscOperatorInitizializer;
